/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ImagesIcon = createIcon("ImagesIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#1C69F2';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.159 17.833c.188.131.351.294.484.481l8.896 12.528A2 2 0 0135.908 34h-7.856l.04.054H12.197a2 2 0 01-1.65-3.13l5.843-8.523a2 2 0 013.272-.039l1.465 2.034 4.245-6.07a2 2 0 012.786-.493ZM15 12a3 3 0 110 6 3 3 0 010-6Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.ImagesIcon",
  "replaceColor": true
});